const defaultProcessor = require('./default');

module.exports = function (eventName, eventData) {
  const processChange = !_.all(eventData.elements, function (elem) {
    return $(elem).is('.layoutClipperImage');
  });

  if (!processChange) {
    const deferred = $.Deferred();
    deferred.reject(new Error('Crop exception failed'));
    return deferred.promise();
  }

  return defaultProcessor.apply(this, arguments);
};
